import React, { createContext } from "react";

export const ModalContext = createContext<any>(undefined);

export const CommonValueContext = createContext<any>(undefined);

export const ContextExtraData = createContext<any>(undefined);
